import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import CargoList from '../../../components/Purchasing/Cargo/CargoList'
import CreateFreightModal from '../../../components/Purchasing/Cargo/CreateFreightModal'
import OrderList from '../../../components/Purchasing/Order/OrderList'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row, Tabs } from 'antd'
import React, { Fragment } from 'react'

const { TabPane } = Tabs

const { Content } = Layout

function Cargo(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb
              items={[
                { text: 'Purchasing' },
                { text: 'Order' },
                { text: 'Delivery', link: '#/purchasing/delivery/list' },
                { text: 'Cargo', link: '#/purchasing/cargo' },
              ]}
            />
            <PageTitle
              title={'Cargo'}
              subtitle={
                'Cargo is the consignment of goods (the collection of packages) that form a single block.  The cargo is also the storage point of documents relating to it.'
              }
              color={'#427035'}
              iconType={'code-sandbox'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <CreateFreightModal {...props} />
          <Card>
            <Tabs defaultActiveKey={'#cargo'}>
              <TabPane tab="Cargo" key="#cargo">
                <CargoList {...props} />
              </TabPane>
              <TabPane tab="Freight Booking" key="#orders">
                <OrderList {...props} />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Cargo.propTypes = {}
Cargo.defaultProps = {}

export default Cargo
